import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-tanta',
  templateUrl: './building-tanta.component.html',
  styleUrls: ['./building-tanta.component.scss']
})
export class BuildingTantaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
